module.exports = __webpack_public_path__ + "static/media/ZOO.425f2da9.png";